export default __webpack_public_path__ + "static/media/Assign_to_me-white.ec65b27e.svg";